// Zahlen-Eingaben (DESIGN §3.6.3): Parsen freier Eingaben, Geldbeträge in Minor Units (SPEC §0).
// Locale en-GB (ANNAHME aus DESIGN §8). Reine Funktionen, getestet in number.test.ts.

export const UI_LOCALE = 'en-GB';

/** Liest „1,250.50“, „$1,250“, „-3“, „12 %“; leer oder ungültig → null. */
export function parseNumberInput(text: string): number | null {
  const cleaned = text.replace(/[\s,%]/g, '').replace(/[^\d.+-]/g, '');
  if (!cleaned || cleaned === '-' || cleaned === '.' || cleaned === '+') return null;
  if (!/^[+-]?(\d+\.?\d*|\.\d+)$/.test(cleaned)) return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
}

/** Nachkommastellen einer Währung laut Intl (USD 2, JPY 0). */
export function currencyDigits(currency: string): number {
  return (
    new Intl.NumberFormat(UI_LOCALE, { style: 'currency', currency }).resolvedOptions()
      .maximumFractionDigits ?? 2
  );
}

/** Hauptbetrag → Minor Units, gerundet (12.345 USD → 1235). */
export function toMinor(major: number, currency: string): number {
  return Math.round(major * 10 ** currencyDigits(currency));
}

/** Minor Units → Hauptbetrag. */
export function fromMinor(minor: number, currency: string): number {
  return minor / 10 ** currencyDigits(currency);
}

/** Anzeige im Feld nach dem Verlassen: „1,250.00“ (ohne Symbol, das steht als Präfix). */
export function formatMinorPlain(minor: number, currency: string): string {
  const digits = currencyDigits(currency);
  return new Intl.NumberFormat(UI_LOCALE, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(fromMinor(minor, currency));
}

/** Währungssymbol für das Präfix („$“, „€“, „£“, „CHF“). */
export function currencySymbol(currency: string): string {
  const part = new Intl.NumberFormat(UI_LOCALE, { style: 'currency', currency })
    .formatToParts(0)
    .find((p) => p.type === 'currency');
  return part?.value ?? currency;
}

/** Zahl für die Anzeige im Feld (Tausender-Trenner, höchstens `maxDigits` Nachkommastellen). */
export function formatPlain(value: number, maxDigits = 2): string {
  return new Intl.NumberFormat(UI_LOCALE, { maximumFractionDigits: maxDigits }).format(value);
}

/** Begrenzt auf [min, max]. */
export function clamp(value: number, min = -Infinity, max = Infinity): number {
  return Math.min(max, Math.max(min, value));
}
